export default __webpack_public_path__ + "static/media/eth.e046c27b.png";